import React from 'react';
import { Download } from 'lucide-react';

const statusColors = {
  new: 'bg-blue-500',
  contacted: 'bg-yellow-500',
  booked: 'bg-green-500',
  declined: 'bg-red-500',
};

export function InquiriesTab({ inquiries, onUpdateStatus, onExport }) {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-medium text-white">Booking Inquiries</h3>
        <button
          onClick={onExport}
          className="flex items-center gap-2 bg-gold-500 hover:bg-gold-400 px-4 py-2 rounded-lg text-black text-sm font-medium transition-colors"
          data-testid="export-bookings-btn"
        >
          <Download size={16} />
          Export CSV
        </button>
      </div>
      {inquiries.length === 0 ? (
        <div className="bg-gray-800/50 rounded-xl border border-gray-700 p-8 text-center text-gray-500">
          No booking inquiries yet
        </div>
      ) : (
        inquiries.map((inq) => (
          <div key={inq.id} className="bg-gray-800/50 rounded-xl border border-gray-700 p-6">
            <div className="flex flex-wrap items-start justify-between gap-4 mb-4">
              <div>
                <h3 className="text-xl font-semibold text-gold-400">{inq.name}</h3>
                <p className="text-gray-400">{inq.email} • {inq.phone}</p>
              </div>
              <div className="flex items-center gap-3">
                <select
                  value={inq.status}
                  onChange={(e) => onUpdateStatus(inq.id, e.target.value)}
                  className={`px-4 py-2 rounded-lg text-white text-sm font-medium ${statusColors[inq.status] || 'bg-gray-500'} border-0 cursor-pointer`}
                  data-testid={`status-select-${inq.id}`}
                >
                  <option value="new">New</option>
                  <option value="contacted">Contacted</option>
                  <option value="booked">Booked</option>
                  <option value="declined">Declined</option>
                </select>
              </div>
            </div>

            <div className="grid md:grid-cols-3 gap-4 mb-4">
              <div className="bg-gray-900/50 rounded-lg p-3">
                <p className="text-gray-500 text-xs uppercase mb-1">Event Date</p>
                <p className="text-white">{inq.event_date}</p>
              </div>
              <div className="bg-gray-900/50 rounded-lg p-3">
                <p className="text-gray-500 text-xs uppercase mb-1">Location</p>
                <p className="text-white">{inq.event_location}</p>
              </div>
              <div className="bg-gray-900/50 rounded-lg p-3">
                <p className="text-gray-500 text-xs uppercase mb-1">Event Type</p>
                <p className="text-white">{inq.event_type}</p>
              </div>
            </div>

            <div className="bg-gray-900/50 rounded-lg p-4">
              <p className="text-gray-500 text-xs uppercase mb-2">Message</p>
              <p className="text-gray-300 whitespace-pre-wrap">{inq.message}</p>
            </div>

            <p className="text-gray-500 text-sm mt-4">
              Submitted: {new Date(inq.submitted_at).toLocaleString()}
            </p>
          </div>
        ))
      )}
    </div>
  );
}
